/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'newsfeed': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g _fill="none" fill-rule="evenodd"><mask id="svgicon_newsfeed_a" _fill="#fff"><path pid="0" d="M15 0a3 3 0 013 3v12a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h12zm0 2H3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V3a1 1 0 00-1-1zM4 5a1 1 0 001 1c3.877 0 7 3.123 7 7a1 1 0 002 0c0-4.959-4.041-9-9-9a1 1 0 00-1 1zm0 4a1 1 0 001 1c1.668 0 3 1.332 3 3a1 1 0 002 0c0-2.75-2.25-5-5-5a1 1 0 00-1 1zm1 3a1 1 0 100 2 1 1 0 000-2z"/></mask><path pid="1" d="M15 0a3 3 0 013 3v12a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h12zm0 2H3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V3a1 1 0 00-1-1zM4 5a1 1 0 001 1c3.877 0 7 3.123 7 7a1 1 0 002 0c0-4.959-4.041-9-9-9a1 1 0 00-1 1zm0 4a1 1 0 001 1c1.668 0 3 1.332 3 3a1 1 0 002 0c0-2.75-2.25-5-5-5a1 1 0 00-1 1zm1 3a1 1 0 100 2 1 1 0 000-2z" _fill="#000" fill-rule="nonzero"/><path pid="2" _fill="#22262A" mask="url(#svgicon_newsfeed_a)" d="M-3-3h24v24H-3z"/></g>'
  }
})
